import { Component, OnInit, ViewEncapsulation, Inject, OnDestroy } from "@angular/core";
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { Device } from "../../shared/interface/device";
import { Site } from "../../shared/interface/site";
import { DeviceType } from "../../shared/interface/device-type";
import { DeviceService } from "../../shared/services/device/device.service";
import { SiteService } from "../../shared/services/site/site.service";
import { CommonService } from "../../shared/services/common/common.service";
import { KpiGroups } from "../../shared/interface/kpi-groups";
import { Observable } from "rxjs/Observable";
import {
  FormGroup,
  FormBuilder,
  Validators
} from "@angular/forms";
import { FormArray } from "@angular/forms/src/model";
import "rxjs/add/operator/debounceTime";
import { Subject } from 'rxjs/Subject';
import { environment } from '../../../environments/environment';
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-devices",
  templateUrl: "./devices.component.html",
  styleUrls: ["./devices.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class DevicesComponent implements OnInit, OnDestroy {
  private _unsubscribeAll  : Subject<any> = new Subject<any>();
  dataSource: Device[];
  pageLength: number;
  pageSize: number = 10;
  pageSizeOptions = [10, 25, 50];
  pageEvent: any;
  filter: any = {
    page: 1,
    limit: 10,
    where: {}
  };
  private subject: Subject<string> = new Subject();
  searchLoading = 0;
  dataSite: Site[] = [];
  deviceButtonDisabled = true;

  constructor(private deviceService: DeviceService, private siteService: SiteService, public dialog: MatDialog, private commonService: CommonService) { }

  ngOnInit() {
    this.getSiteList();
    this.setList(this.filter, 1);
    this.deviceService.getAction().pipe(takeUntil(this._unsubscribeAll)).subscribe(data => {
      if (["create", "update"].includes(data.action)) {
        this.setList(this.filter, 1);
      }
      if (["errorResolved", "fetchData"].includes(data.action)) {
        this.setList(this.filter);
      }
      if (["applySiteFilterToDevice"].includes(data.action)) {
        this.filter.where.siteId = data.data.siteId;
        this.setList(this.filter, 1);
      }
      if (["updateSiteCount"].includes(data.action)) {
        this.getSiteList();
      }
    });
    this.subject.debounceTime(400).pipe(takeUntil(this._unsubscribeAll)).subscribe(filterTerm => {
      this.filter.page = 1;
      this.filter.limit = 10;
      this.filter.where.deviceName = filterTerm;
      this.setList(this.filter, 1);
    });
  }

  ngOnDestroy(){
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
  
  getSiteList() {
    this.siteService.list("fields=siteName,isActive,address").pipe(takeUntil(this._unsubscribeAll)).subscribe(r => {
      this.dataSite = r;
      this.deviceButtonDisabled = (r.length >= 1 ? false : true);
    });
  }

  filterData(filterTerm) {
    this.subject.next(filterTerm);
    this.searchLoading = 1;
  }

  filterDataBySite(siteId) {
    this.filter.where.siteId = siteId;
    if (!this.filter.where.siteId) {
      this.filter.where.siteId = "";
    }
    this.filter.page = 1;
    this.filter.limit = 10;
    this.setList(this.filter, 1);
  }

  paginateData(pageEvent) {
    this.filter.page = pageEvent.pageIndex + 1;
    this.filter.limit = pageEvent.pageSize;
    this.setList(this.filter);
  }

  setList(filter = {}, loadCount = 0) {
    let filterString = this.commonService.buildFilter(filter);
    if (loadCount == 1) {
      this.deviceService.count(filterString).pipe(takeUntil(this._unsubscribeAll)).subscribe(
        res => {
          this.pageLength = (res.count ? res.count : 0);
          this.searchLoading = 0;
        },
        err => { }
      );
    }
    this.deviceService.list(filterString).pipe(takeUntil(this._unsubscribeAll)).subscribe(
      res => {
        this.dataSource = res;
        this.searchLoading = 0;
      },
      err => { }
    );
  }

  openDeviceDialog = (data = {}) => {
    let mData: any = data;
    //mData.sites = this.dataSite;

    this.dialog.open(DeviceDialog, {
      data: mData,
      height: "auto",
      width: "800px",
      panelClass: "full-modal"
    });
  };

  openErrorDialog = (deviceId, errorMsg) => {
    let data = {
      deviceId: deviceId,
      lastError: errorMsg
    }
    this.dialog.open(DeviceErrorDialog, {
      data: data,
      height: "auto",
      width: "400px",
      panelClass: "full-modal"
    });
  }

  openFetchDataDialog = (deviceId) => {
    let data = {
      deviceId: deviceId
    }
    this.dialog.open(DeviceFetchDataDialog, {
      data: data,
      height: "auto",
      width: "400px",
      panelClass: "full-modal"
    });
  }

  // Delete Device
  delete(_id: string) {
    if (
      confirm(
        "Are you sure you want to remove this device. Note: Device deletion will cause you to lose all KPI's data"
      ) == false
    ) {
      return false;
    }

    let temp = this.dataSource;
    this.dataSource = this.dataSource.filter(item => item["_id"] !== _id);
    this.deviceService.delete(_id).pipe(takeUntil(this._unsubscribeAll)).subscribe(
      r => {
        this.pageLength -= 1;
        this.siteService.sendAction("update", "")
      },
      e => {
        this.dataSource = temp;
      }
    );
  }
}

@Component({
  selector: "device-dialog",
  templateUrl: "device.dialog.html",
  styleUrls: ["./devices.component.scss"]
})
export class DeviceDialog implements OnDestroy{
  dataSource: Device[];
  private _unsubscribeAll  : Subject<any> = new Subject<any>();
  deviceForm: FormGroup;
  dataSite$: Observable<Site[]>;
  dataDeviceType$: Observable<DeviceType[]>;
  kpiGroupsValues: KpiGroups[] = [];
  kpiGroups = [];
  connectionComplete = 0;
  isTried = 0;
  connectionLoading = 0;
  isSubmitted: number = 0;
  defaultDeviceImage: string = "assets/img/default-placeholder.png";

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private deviceService: DeviceService,
    private siteService: SiteService,
    private commonService: CommonService,
    public dialogRef: MatDialogRef<DeviceDialog>
  ) {
    this.dataSite$ = this.siteService.list();
    this.dataDeviceType$ = this.deviceService.types();

    data = this.parseData(data);
    this.createForm(data);
  }

  ngOnDestroy(){
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  createForm(data: Device) {
    this.deviceForm = this.fb.group({
      _id: [data._id],
      deviceTypeId: [data.deviceTypeId, Validators.required],
      deviceName: [data.deviceName, Validators.required],
      siteId: [data.siteId, Validators.required],
      deviceIp: [data.deviceIp, Validators.required],
      deviceMac: [data.deviceMac, Validators.compose([Validators.required, Validators.pattern('^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$')])],
      deviceConfLink: data.deviceConfLink,
      devicePassword: "",
      deviceType: "single-sensor",
      deviceImage: data.deviceImage,
      deviceImageFile: [],
      ip: [data.ip, Validators.required],
      port: [data.port, Validators.required],
      userName: [data.userName, Validators.required],
      password: [data.password, Validators.required],
      folderPath: [data.folderPath, Validators.required],
      kpiMode: [data.kpiMode, Validators.required],
      kpiGroups: this.fb.array([]),
      elementsConfig: this.fb.group({
        Adult: [data.elementsConfig.Adult, Validators.pattern("[0-9]+(,[0-9]+)*")],
        Child: [data.elementsConfig.Child, Validators.pattern("[0-9]+(,[0-9]+)*")],
        Staff: [data.elementsConfig.Staff, Validators.pattern("[0-9]+(,[0-9]+)*")]
      }),
      checkForData: [data.checkForData, Validators.required],
      PeriodMins: [data.PeriodMins, Validators.pattern("^[1-5]?[0-9]$")],
      isActive: data.isActive
    });

    if (data.deviceTypeId) {
      this.getKpis(data.deviceTypeId, data.kpiGroups);
    }
  };

  parseData(data: any) {
    if (data && data.deviceTypeId) {
      if (!data.elementsConfig) {
        data.elementsConfig = {
          Adult: "0,1,2",
          Child: "3,4,5",
          Staff: "6,7,8"
        };
      }
      if (!data.deviceImage || data.deviceImage == this.defaultDeviceImage) {
        data.deviceImage = this.defaultDeviceImage;
      } else {
        if (data.deviceImage && data.deviceImage.indexOf("s3.amazonaws.com") == -1) {
          data.deviceImage = "https://xpandretail-assets.s3.amazonaws.com/" + data.deviceImage;
        }
      }

      if (data && !isNaN(data.checkForData)) {
        data.checkForData = "Custom";
      }
      return data;
    }
    return {
      _id: "",
      deviceTypeId: "",
      deviceName: "",
      siteId: "",
      deviceIp: "",
      deviceMac: "",
      deviceConfLink: "",
      deviceImage: this.defaultDeviceImage,
      ip: "",
      port: 22,
      userName: "",
      password: "",
      folderPath: "",
      kpiMode: "",
      kpiGroups: this.kpiGroups,
      elementsConfig: {
        Adult: "0,1,2",
        Child: "3,4,5",
        Staff: "6,7,8"
      },
      checkForData: "",
      isActive: 1
    };
  }

  getKpiGroups() {
    return <FormArray>this.deviceForm.get('kpiGroups');
  }

  getElementsConfig() {
    return <FormGroup>this.deviceForm.get('elementsConfig');
  }

  removeDeviceImage() {
    this.deviceForm.patchValue({
      deviceImage: this.defaultDeviceImage
    })
  }

  updateDeviceImage(files: FileList) {
    if (files.length == 0) {
      return;
    }

    if (files[0].size > 200000) {
      alert("file size should be less than 200kb");
      return false;
    }

    var reader = new FileReader();
    var _this = this;
    reader.onloadend = function (e) {
      _this.deviceForm.patchValue({
        deviceImage: reader.result,
        deviceImageFile: reader.result
      })
    }

    reader.readAsDataURL(files[0]);
  }

  fetchImageFromDevice() {
    //https://control.xpandretail.com/sensor/00-1E-C0-9D-29-F8/api/scene/background/grayscale?passwd=pass
    //https://control.xpandretail.com/sensor/00-1E-C0-9D-29-F8/api/multisensor/background?passwd=pass
    let url = "";
    let deviceMac = this.deviceForm.value.deviceMac;
    let devicePassword = this.deviceForm.value.devicePassword;
    let _this = this;


    deviceMac = deviceMac.split(':').join("-");
    if (deviceMac == "") {
      alert("Please enter device mac to fetch image.");
      return;
    }
    if (this.deviceForm.value.deviceType == "single-sensor") {
      url = "https://control.xpandretail.com/api/v1/devices/" + deviceMac.split(":").join("-") + "/access/api/scene/background/grayscale";
    } else {
      url = "https://control.xpandretail.com/api/v1/devices/" + deviceMac.split(":").join("-") + "/access/api/multisensor/background";
    }

    this.commonService.imageToDataUrl(environment.baseUrl + "device/getImageByUrl/" + encodeURIComponent(url), function (result) {
      if (!result) {
        alert("please make sure you are login to control.xpandretail.com when fetching image");
        return;
      }

      _this.deviceForm.patchValue({
        deviceImage: result,
        deviceImageFile: result
      })
    });
  }

  onSubmit(form: any) {
    if (!this.deviceForm.valid) {
      return false;
    }
    this.isSubmitted = 1;

    //if default image blank it
    if (form.deviceImage == this.defaultDeviceImage || form.deviceImageFile == form.deviceImageFile) {
      form.deviceImage = "";
    }
    if (form.deviceImageFile) {
      form.deviceImageFile = form.deviceImageFile.split("base64,")[1];
    }


    let tempG = [];
    form.kpiGroups.forEach((v, i) => {
      if (v) {
        tempG.push(this.kpiGroupsValues[i]._id);
      }
    });
    form.kpiGroups = tempG;

    //If checkForData is custom pass period value inside checkForData
    if (form.checkForData == "Custom") {
      form.checkForData = form.PeriodMins;
    }
    
    //create device
    if (form._id == "") {
      this.deviceService.create(form).pipe(takeUntil(this._unsubscribeAll)).subscribe(
        res => {
          this.dialogRef.close();
          this.deviceService.sendAction("create", "");
          this.siteService.sendAction("update", "");
          this.isSubmitted = 0;
        },
        err => {
          this.isSubmitted = 0;
        }
      );
    } else {
      //update device
      if (form.isActive == true) {
        form.isActive = 1;
      } else {
        form.isActive = 0;
      }
      form.deviceId = form._id;
      this.deviceService.update(form).pipe(takeUntil(this._unsubscribeAll)).subscribe(
        res => {
          this.dialogRef.close();
          this.deviceService.sendAction("update", "");
          this.siteService.sendAction("update", "");
          this.isSubmitted = 0;
        },
        err => {
          this.isSubmitted = 0;
        }
      );
    }
  }

  public getKpis(value: string, kpiGroupsUpdate: any = []) {
    this.deviceService.kpiGroups(value).pipe(takeUntil(this._unsubscribeAll)).subscribe(
      res => {
        this.kpiGroupsValues = res;
        this.kpiGroups = [];

        let checkbox = false;
        this.kpiGroupsValues.forEach(v => {
          let checkbox = false;
          kpiGroupsUpdate.forEach(e => {
            if (v._id == e.kpiGroupId) {
              checkbox = true;
            }
          });
          this.kpiGroups.push(checkbox);
        });
        this.deviceForm.setControl("kpiGroups", this.fb.array(this.kpiGroups));
      },
      err => { }
    );
  }

  checkDeviceConnection(ip, port = 22, userName, password) {
    this.connectionLoading = 1
    let data = {
      ip: ip,
      port: port,
      userName: userName,
      password: password
    }
    this.deviceService.checkConnection(data).pipe(takeUntil(this._unsubscribeAll)).subscribe(
      res => {
        this.connectionLoading = 0;
        this.isTried = 1;
        this.connectionComplete = 1;
      },
      (err) => {
        this.connectionLoading = 0;
        this.isTried = 1;
        this.connectionComplete = 0;
      }
    )
  }
}

@Component({
  selector: "error-dialog",
  template: "<h2 mat-dialog-title>Error Details</h2>\
  <form><mat-dialog-content><code class='device-error'>{{data.lastError}}</code>\
      </mat-dialog-content>\
      <mat-dialog-actions>\
          <button mat-button mat-dialog-close>Cancel</button>\
          <button type='submit' mat-button (click)='resolveError(data.deviceId)'>Resolve</button>\
      </mat-dialog-actions>\
  </form>"
})
export class DeviceErrorDialog implements OnDestroy{
  private _unsubscribeAll  : Subject<any> = new Subject<any>();
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private deviceService: DeviceService, public dialogRef: MatDialogRef<DeviceErrorDialog>) { }

  resolveError(deviceId) {
    this.deviceService.resolve(deviceId).pipe(takeUntil(this._unsubscribeAll)).subscribe(
      res => {
        this.deviceService.sendAction("errorResolved", deviceId);
        this.dialogRef.close();
      },
      (err) => { }
    )
  }

  ngOnDestroy(){
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

}

@Component({
  selector: "fetch-data-dialog",
  template: "<h2 mat-dialog-title>Device</h2>\
  <form>\
      <mat-dialog-content>\
      Are you sure you want to force this device to fetch data now?\
      </mat-dialog-content>\
      <mat-dialog-actions>\
          <button mat-button mat-dialog-close>Cancel</button>\
          <button type='submit' mat-button (click)='fetchData(data.deviceId)'>Fetch</button>\
      </mat-dialog-actions>\
  </form>"
})
export class DeviceFetchDataDialog implements OnDestroy {
  private _unsubscribeAll  : Subject<any> = new Subject<any>();
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private deviceService: DeviceService, public dialogRef: MatDialogRef<DeviceErrorDialog>) { }

  fetchData(deviceId) {
    this.deviceService.fetchData(deviceId).pipe(takeUntil(this._unsubscribeAll)).subscribe(
      res => {
        this.deviceService.sendAction("fetchData", deviceId);
        this.dialogRef.close();
      },
      (err) => { }
    )
  }

  ngOnDestroy(){
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/profile/devices/devices.component.ts